var React = require('react');

function FaqIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M17.001 22.891a10.34 10.34 0 0 1-2.001.097C10.273 22.77 7 19.467 7 16c0-3.588 3.505-7 8.5-7s8.5 3.412 8.5 7c0 3.216-2.817 6.292-6.999 6.894v-.003zm-7.446.529c1.63.96 3.59 1.537 5.705 1.578C16.32 29.007 20.502 32 25.5 32c1.896 0 3.675-.43 5.21-1.184L34.5 32.5l-1.168-3.505C34.992 27.403 36 25.303 36 23c0-4.902-4.572-8.888-10.26-8.998C24.68 9.993 20.498 7 15.5 7 9.701 7 5 11.03 5 16c0 2.063.81 3.965 2.172 5.483L6 25l3.555-1.58zM25.5 30c-4.113 0-7.216-2.314-8.183-5.134 4.928-.737 8.677-4.42 8.683-8.854 4.727.218 8 3.521 8 6.988 0 3.588-3.505 7-8.5 7z","fill":"#fff"}));
}

FaqIcon.defaultProps = {"width":"40","height":"40","viewBox":"0 0 40 40","fill":"none"};

module.exports = FaqIcon;

FaqIcon.default = FaqIcon;
